import { showApiErrorNotification, useApiMutation } from '@vrplatform/data';
import { hideNotification } from '@vrplatform/theme';
import { showLoadingNotification } from '@vrplatform/theme';
import { useCallback, useId } from 'react';
import { useAutomationHistoryDrawer } from './useAutomationHistoryDrawer';

export const useExtractMutation = () => {
  const { open: openAutomationHistoryDrawer } = useAutomationHistoryDrawer();
  const notifyId = useId();

  const { mutateAsync, isPending: loading } = useApiMutation(
    'post',
    '/connections/extract'
  );

  const extract = useCallback(
    async ({
      connectionId,
      params,
      extractor,
      forceUpdate,
      refreshQueryKeys,
      openSync = true,
    }: {
      connectionId: string;
      extractor: string | undefined;
      openSync?: boolean;
      forceUpdate?: boolean;
      params: {
        uniqueRef?: string | null;
        date?: string | null;
      };
      refreshQueryKeys?: NonNullable<
        Parameters<typeof openAutomationHistoryDrawer>[1]
      >['refreshQueryKeys'];
    }) => {
      try {
        showLoadingNotification({
          id: notifyId,
        });

        const results = await mutateAsync({
          body: {
            connections: [
              {
                forceUpdate,
                connectionId,
                params,
                type: extractor,
              },
            ],
          },
        });

        const syncIds = results.data.data.map((x) => x.syncId);

        hideNotification({ id: notifyId });

        if (openSync) {
          openAutomationHistoryDrawer(syncIds, {
            type: 'push',
            refreshQueryKeys,
          });
        }
      } catch (error: any) {
        console.error(error);
        showApiErrorNotification({
          id: notifyId,
          error,
          title: 'Failed to refetch',
          defaultMessage:
            'Failed to refetch. Please reach out to us if the issue persists.',
        });
      }
    },
    [notifyId, mutateAsync, openAutomationHistoryDrawer]
  );

  return {
    mutate: extract,
    loading,
  };
};
